import $ from 'jquery';
import React, { useEffect } from 'react'
import logo from './images/sd.png'
import './landing.css';
const scroll = () =>
{
    var height = $('.first-container').height();
                console.log('hi');
                var scrollTop = $(window).scrollTop();

                if (scrollTop >= height - 40) {
                    $('.nav-container').addClass('solid-nav');
                } else {
                    $('.nav-container').removeClass('solid-nav');
                }
}

function Navbar() {
    function close() {
        var check = document.getElementById("menuclose");
        if (check.checked == true) {
            check.checked = false;
        }
    };

    return (
        <div>
            <div className="first-container">
                <div className="nav-container">
                    <div className="nav-row">
                        <img src={logo} alt="logo" class="logo" />
                        <div className='Heading nav-logo'>Study Date </div>

                        <div className="nav-controls">
                            <a href="/#">Home</a>
                            <a href="/#about">About</a>
                            <a href="/#features">Features</a>
                            <a href="./login">Login</a>
                            <a href="./signup">Signup</a>
                        </div>
                    </div>
                </div>
            </div>
            <nav role="navigation">
                <div id="menuToggle">
                
                    <input id="menuclose" type="checkbox" />
                    <span></span>
                    <span></span>
                    <span></span>
                    
                    <ul id="menu">
                        <li><a onClick={close} href="/#">Home</a></li>
                        <li><a onClick={close} href="/#about">About</a></li>
                        <li><a onClick={close} href="/#features">Features</a></li>
                        <li><a onClick={close} href="./login">Login</a></li>
                        <li><a onClick={close} href="./signup">Signup</a></li>
                    </ul>
                </div>
                <div className='Heading'>Study Date </div>
                <img src={logo} alt="logo" class="logo" />
            </nav>

        </div>
        

    );
}
export default Navbar;
export {scroll};